var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"tests-filter pt-4",attrs:{"cols":"12","sm":"3"}},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"cols":"12","lg":"10"}},[_c('b-row',[_c('b-col',[_c('h4',{staticClass:"mb-5 font-weight-light"},[_vm._v("Filter Tests")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-188cbb77","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TestsFilter.vue
// module id = null
// module chunks = 